import { get } from 'lodash';

const startReturnsEvent = action => {
  const shopID = get(action, ['payload', 'shopID']);

  if (!shopID) {
    return null;
  }

  return {
    hitType: 'event',
    eventAction: 'startReturn',
    eventCategory: 'Returns',
    eventLabel: shopID,
    eventValue: 1,
  };
};

export { startReturnsEvent };
